import { gql } from 'graphql-request'

const GET_GROUP_PRODUCTS = gql`
  query getProducts(
    $limit: Int
    $offset: Int
    $slug: String
    $type: [String!]
    $topic: [bigint!]
    $product_categories: [bigint!]
    $creator_categories: [bigint!]
    $collections: [bigint!]
    $price_from: Int
    $price_to: Int
  ) {
    products(
      limit: $limit
      offset: $offset
      order_by: { score: desc, id: desc }
      where: {
        _and: [
          {
            product_group_connections: {
              product_group: { slug: { _eq: $slug } }
            }
          }
          { type: { _in: $type } }
          { status: { _eq: "active" } }
          { visible: { _eq: "true" } }
          {
            _or: [
              {
                product_contest_entries: {
                  price: {
                    price_subunit: { _gte: $price_from, _lte: $price_to }
                  }
                }
              }
              {
                price: { price_subunit: { _gte: $price_from, _lte: $price_to } }
              }
            ]
          }
          {
            product_categories: {
              _and: [
                { product_category_id: { _in: $topic } }
                { product_category_id: { _in: $product_categories } }
              ]
            }
          }
          { creator: { creator_category_id: { _in: $creator_categories } } }
          { _not: { type: { _eq: "Product::FansiForBrands" } } }
        ]
      }
    ) {
      id
      slug
      name
      cover: main_photo_url
      created_at
      duration: duration_of_event
      type
      status
      visible
      embedded_link

      creator {
        id
        slug
        nickname
        avatar: avatar_link
      }

      categories: product_categories {
        id: product_category_id
        category: product_category {
          id
          name
        }
      }

      entries: product_contest_entries {
        id
        name
        price {
          value: price_subunit
          currency: price_currency
        }
      }

      price {
        currency: price_currency
        value: price_subunit
        price_before_discount: price_before_discount_subunit
      }
    }
  }
`

export default GET_GROUP_PRODUCTS
